<template>
<router-view></router-view>
</template>

<script>
export default {
  name: 'Agent'
};
</script>

<style lang="less" scoped>
</style>
